<template>
    <component :is="template">
        <v-responsive v-if="ready && exchangeOrder" width="100%">
            <v-card elevation="0" tile max-width="100%">
                <v-card-title class="tit tit--lg">
                    <span class="py-4 pl-4"><b>교환결과</b></span>
                </v-card-title>
            </v-card>

            <v-card elevation="0" tile max-width="100%">
                <v-divider/>
                <v-card-text class="text-center">
                    <div class="tit tit--xs">모바일 도서교환권 교환</div>
                    <div class="font-size-16">
                        <div>교환·결제가 완료되었습니다.</div>
                    </div>
                </v-card-text>

                <v-divider/>

                <pickup-item :cart="exchangeOrder.purchase" />

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0>총 상품가격</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ exchangeOrder.saleAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>총 배송비</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ exchangeOrder.shippingAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>캐시 사용</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>- {{ exchangeOrder.cashAmount.format() }} 원</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0>총 주문 금액</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ exchangeOrder.totalAmount.format() }} 원</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider />

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0><b>결제 금액</b></v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0><b>{{ exchangeOrder.paymentAmount.format() }} 원</b></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">구매자</v-card-title>
                <v-card-text class="pt-0">
                    <v-layout wrap class="mx-n2 mt-n4">
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이름</div><div class="font-size-14 black--text">{{ exchangeOrder.buyer.name || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">연락처</div><div class="font-size-14 black--text">{{ exchangeOrder.buyer.phone || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이메일</div><div class="font-size-14 black--text">{{ exchangeOrder.buyer.email || "-" }}</div></div></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">수취인(받는사람)</v-card-title>
                <v-card-text>
                    <v-layout wrap class="mx-n2 mt-n4">
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이름</div><div class="font-size-14 black--text">{{ exchangeOrder.receiver.name || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">연락처</div><div class="font-size-14 black--text">{{ exchangeOrder.receiver.phone || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이메일</div><div class="font-size-14 black--text">{{ exchangeOrder.receiver.email || "-" }}</div></div></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">요청사항</v-card-title>
                <v-card-text>
                    {{ exchangeOrder.demand || "-" }}
                </v-card-text>
            </v-card>

            <v-layout class="mt-4" justify-center>
                <v-btn x-large color="white" elevation="0" class="mx-1" to="/">홈으로가기</v-btn>
                <v-btn x-large color="primary" elevation="0" class="mx-1" to="/mypage/shop/purchases">주문내역확인</v-btn>
            </v-layout>

        </v-responsive>
    </component>
</template>
<script>
import api from "@/api";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
export default {
    components: {
        PickupItem,
    },
    data(){
        return {
            mdiReceipt,
            mdiBookOpenPageVariant,

            ready: false,
            exchangeOrder: null,

            resCode: this.$route.query.resCode,
            resMessage: this.$route.query.resMessage
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let { order: exchangeOrder } = await api.v1.me.shop.orders.get({ _id: this.$route.query._exchangeOrder });
            this.exchangeOrder = exchangeOrder;
            this.ready = true;
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
    }
}
</script>

<style scoped>
.row + .row {
    margin-top: 0px;
}
.v-input >>> .v-input__slot:before {
    bexchangeOrder: 0 !important;
}
</style>